<div fxLayout="column" fxLayoutAlign="start center" class="block-container">
    <div *ngIf="player != undefined" class="block-username" fxLayout="row">
        <img src="assets/avatars/{{avatarsImgs[player.avatar]}}.png" height="36">
        <img class="img-badge" *ngIf="player.hasLost" src="assets/looser.png" width="72">
        <img class="img-badge" *ngIf="player.hasWon" src="assets/winner.png" width="72">
        <div fxFlex style="font-size: medium;">{{player.username}}</div>
    </div>
    <div class="block-cash">
        <div *ngIf="showAssets" class="cash-title">MY CASH</div>
        <div *ngIf="!showAssets" class="cash-title">CASH</div>
        <div class="border">
            <div class="cash-value">{{cash}}</div>
        </div>
    </div>
    <div class="block-staked">
        <div *ngIf="showAssets" class="cash-title">STAKED</div>
        <div *ngIf="!showAssets" class="cash-title">STAKED</div>
        <div class="border">
            <div class="cash-value">{{staked}}</div>
        </div>
    </div>
    <div class="block-debt">
        <div *ngIf="showAssets" class="cash-title">MY DEBT</div>
        <div *ngIf="!showAssets" class="cash-title">DEBT</div>
        <div class="border">
            <div class="cash-value">{{debt}}</div>
        </div>
    </div>
    <div class="block-assets">
        <div *ngIf="showAssets" class="cash-title">MY ASSETS</div>
        <div *ngIf="!showAssets" class="cash-title">ASSETS</div>
        <div class="border">
            <div class="assets-value">{{assetsValue}}
            </div>
            <div class="assets-table" *ngIf="showAssets">
                <table>
                    <tr *ngFor="let asset of _assets">
                        <td><img src="{{asset.image}}" height="24"></td>
                        <td class="asset-cell" [matMenuTriggerFor]="menuEth" [matMenuTriggerData]="asset">{{asset.name}}</td>
                        <td>{{asset.value}}</td>
                    </tr>
                </table>
                <mat-menu #menuEth="matMenu" xPosition="before" class="asset-menu-panel">
                    <ng-template matMenuContent let-detail="detail" let-assetPrice="value" let-assetName="name" let-assetId="assetId">
                        <div>
                            <div>
                                <h2>Details</h2>
                                <p>{{detail}}</p>
                            </div>
                            <div>
                                <h2>Value</h2>
                                <p>{{assetPrice}}</p>
                            </div>
                        </div>
                        <button mat-raised-button (click)="invest(assetId, assetName)">Invest</button>
                        <button mat-raised-button>Sell</button>
                    </ng-template>
                </mat-menu>
            </div>
        </div>
    </div>
</div>
